/**
 * PayPal Configuration
 *
 * Para obtener tus credenciales:
 * 1. Ve a https://developer.paypal.com/dashboard/
 * 2. Crea una app o usa una existente
 * 3. Copia el Client ID
 *
 * IMPORTANTE:
 * - Para desarrollo: usa el Client ID de Sandbox
 * - Para producción: usa el Client ID de Live
 */

export const PAYPAL_CONFIG = {
  // Client ID de PayPal (reemplazar con el tuyo)
  clientId: import.meta.env.VITE_PAYPAL_CLIENT_ID || 'sandbox',

  // Configuración de moneda
  currency: 'USD',

  // Intent de la orden (capture = cobro inmediato)
  intent: 'capture',

  // Comisiones de PayPal Chile
  commission: {
    percentage: 5.4, // 5.4%
    fixed: 0.30 // $0.30 USD por transacción
  }
} as const;

// Paquetes de VCoins en USD para PayPal
export const PAYPAL_PACKAGES = [
  {
    id: 'starter-usd',
    name: 'Starter',
    description: 'Perfecto para empezar',
    vcoins: 10,
    cvs: 10,
    amount_usd: 4.99,
    popular: false,
    recommended: false,
    bestValue: false
  },
  {
    id: 'standard-usd',
    name: 'Standard',
    description: 'El más popular',
    vcoins: 25,
    cvs: 25,
    amount_usd: 8.99,
    popular: true,
    recommended: true,
    bestValue: false
  },
  {
    id: 'advanced-usd',
    name: 'Advanced',
    description: 'Mejor valor',
    vcoins: 50,
    cvs: 50,
    amount_usd: 11.99,
    popular: false,
    recommended: false,
    bestValue: true
  }
] as const;

export type PayPalPackage = typeof PAYPAL_PACKAGES[number];
